import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=587d3de0&scoped=true"
import script from "./Launcher.vue?vue&type=script&lang=js"
export * from "./Launcher.vue?vue&type=script&lang=js"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=587d3de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d3de0",
  null
  
)

export default component.exports